import type { EditorConfig, SerializedTextNode } from 'lexical';
import styles from './flag.module.css';
import { addClassNamesToElement } from '@lexical/utils';
import { $applyNodeReplacement, TextNode } from 'lexical';

export enum FlagNodeType {
    Caution = 'caution-flag',
    Vehicle = 'vehicle-flag',
}

class FlagNode extends TextNode {
    canInsertTextBefore(): boolean {
        return false;
    }

    isTextEntity(): true {
        return true;
    }
}

/** @noInheritDoc */
export class CautionFlagNode extends FlagNode {
    static getType(): string {
        return FlagNodeType.Caution;
    }

    static clone(node: CautionFlagNode): CautionFlagNode {
        return new CautionFlagNode(node.__text, node.__key);
    }

    createDOM(config: EditorConfig): HTMLElement {
        const element = super.createDOM(config);
        addClassNamesToElement(element, styles['flag'], styles['caution']);
        return element;
    }

    static importJSON(serializedNode: SerializedTextNode): CautionFlagNode {
        const node = $createFlagNode(serializedNode.text, FlagNodeType.Caution);
        node.setFormat(serializedNode.format);
        node.setDetail(serializedNode.detail);
        node.setMode(serializedNode.mode);
        node.setStyle(serializedNode.style);
        return node;
    }

    exportJSON(): SerializedTextNode {
        return {
            ...super.exportJSON(),
            type: FlagNodeType.Caution,
        };
    }
}

/** @noInheritDoc */
export class VehicleFlagNode extends FlagNode {
    static getType(): string {
        return FlagNodeType.Vehicle;
    }

    static clone(node: VehicleFlagNode): VehicleFlagNode {
        return new VehicleFlagNode(node.__text, node.__key);
    }

    createDOM(config: EditorConfig): HTMLElement {
        const element = super.createDOM(config);
        addClassNamesToElement(element, styles['flag'], styles['vehicle']);
        return element;
    }

    static importJSON(serializedNode: SerializedTextNode): VehicleFlagNode {
        const node = $createFlagNode(serializedNode.text?.toUpperCase(), FlagNodeType.Vehicle);
        node.setFormat(serializedNode.format);
        node.setDetail(serializedNode.detail);
        node.setMode(serializedNode.mode);
        node.setStyle(serializedNode.style);
        return node;
    }

    exportJSON(): SerializedTextNode {
        return {
            ...super.exportJSON(),
            type: FlagNodeType.Vehicle,
        };
    }
}

export const FlagNodes = [CautionFlagNode, VehicleFlagNode];

export function $createFlagNode(
    text: string,
    type: FlagNodeType
): CautionFlagNode | VehicleFlagNode {
    switch (type) {
        case FlagNodeType.Caution:
            return $applyNodeReplacement(new CautionFlagNode(text));
        case FlagNodeType.Vehicle:
            return $applyNodeReplacement(new VehicleFlagNode(text));
    }
}
